export enum AuditHistoryType {
  Alt = 1,
  Systembeskeder = 2,
  Bemærkninger = 3,
  Fejl = 4,
}

export enum AfregningsType {
  Alle = 1,
  Kundeopkrævninger = 2,
  Partnerafregninger = 3,
}
